import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=715ce9fa&scoped=true&"
import script from "./SelectClass.vue?vue&type=script&lang=js&"
export * from "./SelectClass.vue?vue&type=script&lang=js&"
import style0 from "./SelectClass.vue?vue&type=style&index=0&id=715ce9fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ce9fa",
  null
  
)

export default component.exports